import {RouterProps} from "../../RouterProps";
import {useParams} from "react-router-dom";
import {useStatePair} from "react-type-extension";
import {EnvNoticeValueObject} from "../../../data/value-object/env/EnvNoticeValueObject";
import {JSX, useEffect} from "react";
import {EnvNoticeIO, EnvNoticeModificationIO} from "../../../io/EnvIO";
import {Body1, Spinner, Tab} from "@fluentui/react-components";
import {DetailDefaultPanel, DetailTab} from "../../DetailViews";
import {EnvNoticeDomain} from "../../../data/domain/env/EnvNoticeDomain";
import {EnvNoticeDescriptor} from "../../../data/descriptor/env/EnvNoticeDescriptor";
import {EnvNoticeDescription} from "../../../data/description/env/EnvNoticeDescription";
import {EnvNoticeModificationValueObject} from "../../../data/value-object/env/EnvNoticeModificationValueObject";
import {
    EnvNoticeModificationSearchOption
} from "../../../data/search-option/env/EnvNoticeModificationSearchOption";
import {searchIndex, SearchIndex} from "../../../io/HttpClient";
import ListPageWrapper from "../../ListPageWrapper";
import {EnvNoticeModificationDescription} from "../../../data/description/env/EnvNoticeModificationDescription";
import {EnvNoticeModificationDescriptor} from "../../../data/descriptor/env/EnvNoticeModificationDescriptor";

enum Panel {
    Default,
    EnvNoticeModificationList,
}

export default function Detail(props: RouterProps) {
    const params = useParams<{ envNoticeId: string }>()
    const item = useStatePair<EnvNoticeValueObject | undefined>(undefined)

    useEffect(() => {
        if (item.value === undefined && params.envNoticeId !== undefined) {
            EnvNoticeIO
                .getById(BigInt(params.envNoticeId))
                .then(item.setter)
                .catch(reason => {
                    console.error(reason)
                    alert('오류가 발생했습니다.')
                })
        }
    }, []);

    return <>
        {item.value === undefined && <Spinner />}
        {item.value !== undefined && <Page {...props} item={item.value} /> }
    </>
}

type PageProps = RouterProps & {
    item: EnvNoticeValueObject
}

function Page(props: PageProps) {
    const panel = useStatePair<Panel>(Panel.Default)

    return <>
        <div className={props.styles.row16}>
            <DetailTab
                {...props}
                panel={panel}>
                <Tab value={Panel.Default}>상세</Tab>
                <Tab value={Panel.EnvNoticeModificationList}>수정 이력</Tab>
            </DetailTab>
            <DetailDefaultPanel
                {...props}
                visible={panel.value === Panel.Default}
                client={EnvNoticeIO}
                description={EnvNoticeDescription}
                properties={props => <PropertyBody {...props} />}/>
            <EnvNoticeModificationListPanel
                {...props}
                panel={panel.value}/>
        </div>
    </>
}

type PropertyBodyProps = PageProps & {
    itemKey: keyof EnvNoticeDomain
}

function PropertyBody(props: PropertyBodyProps) {
    switch (props.itemKey) {
        case "id":
        case "title":
        case "url":
        case "lastModifiedAt":
        case "concealedAt":
        case "createdAt":
            return <Body1>{EnvNoticeDescriptor[props.itemKey](props.item)}</Body1>
        case "creatorId":
            return <a href={`/users/${props.item.creatorId}`}><Body1>{EnvNoticeDescriptor[props.itemKey](props.item)}</Body1></a>
    }
}

type PanelProps = PageProps & {
    panel: Panel
    children?: false | JSX.Element | JSX.Element[]
}

function EnvNoticeModificationListPanel(props: PanelProps) {
    const items = useStatePair<EnvNoticeModificationValueObject[]>([])
    const option: EnvNoticeModificationSearchOption = { envNoticeIdEq: props.item.id }
    const index = useStatePair<SearchIndex>(searchIndex())

    return <>
        {props.panel === Panel.EnvNoticeModificationList && <>
            <ListPageWrapper
                {...props}
                client={EnvNoticeModificationIO}
                items={items}
                option={option}
                index={index}
                showNewTab={false}
                description={EnvNoticeModificationDescription}
                descriptor={EnvNoticeModificationDescriptor} />
        </>}
    </>
}